var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHidePassword = function SvgIconHidePassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.04 11.871 2.788 5.617 5.616 2.79l39.598 39.596-2.828 2.83-6.62-6.62A21.9 21.9 0 0 1 24 42.001c-10.784 0-19.756-7.76-21.636-18a22 22 0 0 1 6.676-12.13m20.476 20.474-2.928-2.928a6 6 0 0 1-8.002-8.002l-2.928-2.928a10 10 0 0 0 13.858 13.858M15.948 7.521A22 22 0 0 1 24 6.001c10.784 0 19.756 7.76 21.638 18a21.9 21.9 0 0 1-4.024 9.186l-7.72-7.72a10.06 10.06 0 0 0-.801-5.63 10 10 0 0 0-10.557-5.73z"
  })));
};
export default SvgIconHidePassword;